var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysClearField = function SvgSysClearField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 8a6.999 6.999 0 1 1 13.998 0A6.999 6.999 0 0 1 1 8Zm1 0a6.002 6.002 0 0 0 7.17 5.884A6.001 6.001 0 0 0 8 2a6.01 6.01 0 0 0-6 6Zm8.149 2.851L8 8.705 5.855 10.85a.5.5 0 0 1-.709-.705l2.149-2.144-2.149-2.149a.499.499 0 0 1 .033-.676.5.5 0 0 1 .676-.025L8.001 7.3l2.148-2.147a.5.5 0 0 1 .799.365.502.502 0 0 1-.099.336L8.702 8.002l2.147 2.144a.5.5 0 0 1-.542.815.492.492 0 0 1-.158-.11Z"
  })));
};
export default SvgSysClearField;